<template>
	<popup class="action-popup"
	       :title="`${isEdit?'Edit':'Create a new'} automation`" relative :noscroll="loading" @close="closePopup">
		<template v-slot:content>
			<div class="__content">

				<steps-header :steps="steps" />

				<div class="__action-wrap">
					<Loading v-if="loading"/>
					<component v-else :is="integrationPopup" :is-edit="isEdit" :product="product"
					           :integration="integration" :actions="actions"
					           :automation="localAutomation" @valid="isValid=$event" />

<!--					<GoogleSheets :isPlus="isPlus"-->
<!--					              v-if="integrationId === 6"-->
<!--					              :actions="getActions"-->
<!--					              @done="$emit('done', $event)"-->
<!--					              :data="data"-->
<!--					/>-->

<!--					<Shopify :isPlus="isPlus"-->
<!--					         v-if="integrationId === 5"-->
<!--					         :actions="getActions"-->
<!--					         :funnelProduct="funnelProduct"-->
<!--					         @done="$emit('done', $event)"-->
<!--					         :step-id="stepId" :funnel-id="funnelId" :product-id="productId"-->
<!--					         :data="data"-->
<!--					         :integrationId="integrationId"-->
<!--					         :integrations="integrations" />-->

<!--					<ShipStation :isPlus="isPlus"-->
<!--					             v-if="integrationId === 7"-->
<!--					             :actions="getActions"-->
<!--					             @done="$emit('done', $event)"-->
<!--					             :data="data"-->
<!--					             :integrationId="integrationId"-->
<!--					             :integrations="integrations" />-->

<!--					<ActiveCampaign :isPlus="isPlus"-->
<!--					                v-if="integrationId === 1 || integrationId === 3 || integrationId === 8 || integrationId === 9"-->
<!--					                :actions="getActions"-->
<!--					                @done="$emit('done', $event)"-->
<!--					                :data="data"-->
<!--					                :integrationId="integrationId"-->
<!--					                :integrations="integrations"-->
<!--					/>-->

<!--					<zapier-props v-if="integrationId===13"  />-->
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button v-if="!isEdit" label="Back" slim border @click="$emit('back')" />
			<v-button v-if="isEdit" label="Save changes" :loading="saving" :disabled="!isValid" slim @click="save" />
			<v-button v-else label="Create automation" :loading="saving" :disabled="!isValid" slim @click="save" />
			<v-button label="Cancel" slim border @click="closePopup" />
		</template>
	</popup>
</template>

<script>

import API from "@/api"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import StepsHeader from "@/components/popups/automation/steps/steps-header";
import Shopify from "../integration-actions/shopify/Shopify";
import GoogleSheets from "../integration-actions/GoogleSheets";
import ShipStation from "../integration-actions/ShipStation";
import ActiveCampaign from "../integration-actions/ActiveCampaign";
import ZapierProps from "@/components/integrations/zapier-props";
import Klaviyo from "../integration-actions/Klaviyo";
import Mailchimp from "../integration-actions/Mailchimp";
import Hyros from "../integration-actions/Hyros";

export default {
  name: "action-popup",
	mixins: [API],
	props:{
		isPlus:{type:Boolean},
		automation:{type:Object},
		currentProduct:{type:Object},
		edit:{type:Object},
		product:{},
		stepId:{},
		funnelId:{},
		isEdit:{type:Boolean},
	},
  components: {
	  Hyros,
	  Mailchimp,
	  Klaviyo,
	  ZapierProps,
	  ActiveCampaign,
	  ShipStation,
	  GoogleSheets,
	  Shopify,
	  StepsHeader,
    Popup,
      Loading,
      VButton
  },
  data() {
    return {
	    isValid:false,
	    loading: false,
	    saving:false,
	    step: 1,
	    triggerId:0,
	    integration:{},
	    actions:[],
	    search:'',
	    localAutomation:null,
	    integrationDetails:{
		    1:'ActiveCampaign',
				3:'Klaviyo',
				5:'Shopify',
				6:'GoogleSheets',
		    7:'ShipStation',
		    8:'Hyros',
		    9:'Mailchimp',
		    13:'zapier-props',
	    }
    }
  },
  computed: {
		integrationPopup(){
			return this.integrationDetails[this.localAutomation.integration_id]
		},
		triggerTag() {
			if (!this.localAutomation.trigger_id) return "";
			return ['Purchase','Refund','New subscription',
			        'Subscription canceled','Recurring payment','Recurring payment fails'][this.localAutomation.trigger_id-1]
		},
	  integrationName(){
			return this.integration.caption || ''
	  },
	  actionName(){
			if (!this.actions || !this.localAutomation.type_id) return ""
			let action = this.actions.find(x=>x.id===this.localAutomation.type_id)
		  if (!action) return ""
		  return action.caption;
	  },
		steps(){
			return [
				{
					id: 1, name: "Select a trigger",
					tag: this.triggerTag,
					step: "Step1", status: "completed"
				},
				{
					id: 2, name: "Select an integration",
					tag: this.integrationName,
					step: "Step2", status: "completed"
				},
				{
					id: 3, name: "What action to trigger?",
					tag: this.actionName,
					step: "Step3", status: "active"
				}]
		},
  },
  methods: {
    closePopup() {
	    this.$emit('close');
    },
	  async save() {
		  try {
				this.saving = true;
				let a = JSON.parse(JSON.stringify(this.localAutomation))
				if (a.content) {
					a.content = JSON.stringify(a.content);
				}
				if (a.tags && Array.isArray(a.tags))
					a.tags = a.tags.join(',')
			  else
					a.tags = ''

			  let res = null
			  if (this.isPlus) {
				  if (this.isEdit) res = await this.api.wsteps.patchAutomation(a.id, a);
				  else res = await this.api.wsteps.createAutomation(a);
			  } else {
				  if(this.isEdit) res = await this.api.steps.patchAutomation(a.id, a);
				  else res = await this.api.steps.createAutomation(a);
			  }
				if (!res || res.error) throw res
			  this.$emit('done',a)
		  } catch (e) {
				this.$error(e)
		  } finally {
			  this.saving = false;
		  }
	  },
	  async load() {
		  try {
			  this.loading = true;

				// Load automation if not isEdit.
				if (this.isEdit && this.localAutomation.id) {
					let att = {};
					if (this.isPlus)
						att = await this.api.wsteps.getProductAutomations(this.localAutomation.id);
					else
						att = await this.api.steps.getProductAutomations(this.localAutomation.id);
					this.localAutomation = att

					this.$set(this.localAutomation, "content", att.content ? JSON.parse(att.content) : {}); // reactive.
					this.$set(this.localAutomation, "tags", !!att.tags ? att.tags.split(',') : []); // reactive.
				}

				// load integration details.
			  this.integration = await this.api.integrations.get(this.localAutomation.integration_id);
			  if (!this.integration) {
					throw "something went wrong!"
			  }

				// load actions
			  this.actions = await this.api.integrations.method(this.integration.name, "get-actions", {id: 0, arg1: "", arg2: ""});

		  } catch (e) {
			  this.$error(e);
		  } finally {
			  this.loading = false;
		  }
	  },
  },
	created() {
		if (this.automation) {
			this.localAutomation = JSON.parse(JSON.stringify(this.automation))
		}
		this.load();
	}
}
</script>
<style lang="scss">
.action-popup {
	.popup {
		max-width: 800px;
		.content {
			padding-top: 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.action-popup {
	.__content {
		display: flex;
		flex-direction: column;
	}
	.__action-wrap {
		display: flex;
		flex-direction: column;
		position: relative;
		min-height: 110px;
	}
	.__integration-items {
		margin-top: 15px;
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 5px;
		gap: 15px;
	}
    .bottom-btns {
        display: flex;
        justify-content: flex-end;
        padding: 15px 20px;
        border-top: 1px solid rgba(206, 207, 216, 0.32);
    }

    .body {
      height: 100%;
      display: block;
      min-height: 9px;
      position: relative;
      padding: 10px 20px;
      overflow-y: auto;
      overflow-x: hidden;
      // max-width: 740px;
    }
    .bottom-btns .button {
        margin-left: 30px;
    }

}
</style>

